import React, { useContext } from 'react';
import { Tooltip, Box } from '@mui/material';
import { RegisterFormTooltipContext } from 'src/context/RegisterFormTooltipContext';
import { getRegisterFormTooltipByKey } from 'src/constants/registerFormTooltips';

const RegisterTooltip = ({ title, tooltipKey, children }) => {
  const { enabled, defaultTooltip } = useContext(RegisterFormTooltipContext);
  const resolvedTooltip =
    title || (tooltipKey ? getRegisterFormTooltipByKey(tooltipKey) : '');
  const tooltipText = resolvedTooltip || (enabled ? defaultTooltip : '');

  if (!tooltipText) {
    return children;
  }

  return (
    <Tooltip title={tooltipText}>
      <Box sx={{ width: '100%' }}>
        {children}
      </Box>
    </Tooltip>
  );
};

export default RegisterTooltip;

